<template>
<div v-if="schoolInformation">
    <div class="pc-msg-box" :class="!show_msg_box?'pc-msg-box-hide':''" v-if="is_PC">
        <div class="pc-msg-title">
            <p>在线咨询</p>
            <a href="javascript:;" @click="show_msg_box=false"><i class="el-icon-close"></i></a>
        </div>
        <a href="javascript:;" @click="qqIM">
            <div class="pc-msg-qq">
                <!-- <img src="static/img/icon-qq.svg" alt=""> -->
                <img border="0" :src="'http://wpa.qq.com/pa?p=2:'+ schoolInformation.SchoolQQ +':52'" alt="QQ客服" title="QQ客服">
                <p>{{schoolInformation.SchoolQQ}}</p>
            </div>
        </a>
        <div class="pc-msg-tell">
            <div class="pc-msg-tell-title">
                <i class="el-icon-phone-outline"></i>
                <p>联系电话：</p>
            </div>
            <div class="pc-msg-tell-num">
                <p>{{schoolInformation.SchoolPhone}}</p>
            </div>
        </div>
    </div>

    <div class="pc-float-box" v-if="is_PC">
        <div class="pc-msg pc-box" @click="show_msg_box=true"><a href="javascript:;"><i class="el-icon-chat-dot-round"></i></a></div>
        <a href="javascript:;" @click="postWeChatCenterDialogVisibleTrue">
            <div class="pc-wechat pc-box"><img src="static/img/icon-wechat.svg" alt=""></div>
        </a>
        <a href="javascript:;" @click="postDouyinDialogVisibleTrue">
            <div class="pc-douyin pc-box"><img src="static/img/icon-douyin.svg" alt=""></div>
        </a>
        <div class="pc-box-show" v-if="!scrollType"></div>
        <a href="javascript:;" @click="smoothscroll">
            <div class="pc-up pc-box" v-if="scrollType"><i class="el-icon-top"></i></div>
        </a>
    </div>

    <div class="m-float-box" v-if="!is_PC">
        <div class="m-home" :class="floatBarActive=='home'?'active':''" @click="$router.push('home')"><i class="el-icon-s-home"></i><span>首页</span> </div>
        <div class="m-stars" :class="floatBarActive=='stage'?'active':''" @click="$router.push('stage')"><i class="el-icon-video-camera-solid"></i><span>剧场</span> </div>
        <div class="m-stars" :class="floatBarActive=='stars'?'active':''" @click="$router.push('stars')"><i class="el-icon-s-shop"></i><span>广场</span> </div>
        <!-- <div class="m-tell"><a :href="'tel:'+ schoolInformation.SchoolPhone"><i class="el-icon-phone"></i></a><span>电话</span></div> -->
        <div class="m-wechat" :class="floatBarActive=='userPage'?'active':''" @click="$router.push('userPage')"><i class="el-icon-user-solid"></i><span>我的</span></div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            //获取当前登录设备
            is_PC: this.$store.state.is_PC,
            //显示隐藏在线咨询
            show_msg_box: true,
        }
    },

    components: {

    },

    computed: {
        //滚轮状态
        scrollType() {
            return this.$store.getters.getScrollType;
        },
        //学校信息
        schoolInformation() {
            if (this.$store.getters.get_schoolInformation) {
                return this.$store.getters.get_schoolInformation;
            } else {
                return JSON.parse(localStorage.getItem("school"));
            }
        },
        //floatbar底部active状态页面
        floatBarActive() {
            return this.$store.getters.getFloatBarActive
        },
    },

    created() {

    },

    methods: {
        //回到顶部
        smoothscroll() {
            (function smoothscroll() {
                var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (currentScroll > 0) {
                    window.requestAnimationFrame(smoothscroll);
                    window.scrollTo(0, currentScroll - (currentScroll / 5));
                }
            })();
        },
        //打开微信二维码
        postWeChatCenterDialogVisibleTrue() {
            this.$store.commit('updateCenterDialogVisible', true)
            this.$store.commit('updatemodalStatus', "wechat")
        },
        //打开抖音二维码
        postDouyinDialogVisibleTrue() {
            this.$store.commit('updateCenterDialogVisible', true)
            this.$store.commit('updatemodalStatus', "douyin")
        },
        //QQ聊天
        qqIM() {
            window.open('http://wpa.qq.com/msgrd?v=3&uin=' + this.schoolInformation.SchoolQQ + '&site=qq&menu=yes');
        },
        //进入个人中心
        userPage() {
            this.$router.push({
                path: '/userPage'
            })
        }
    },
}
</script>

<style scoped>
@import './floatBar.css';
</style>



// WEBPACK FOOTER //
// src/components/floatBar/floatBar.vue